import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';

import { Opacity } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';

import Card from '../Card';
import SemDados from '../SemDados';

function CardTiposAbast({ data, style }) {
  const [colors, setColors] = useState([]);
  const [sum, setSum] = useState(0);

  // Gera as cores do gráfico conforme a ordem dos dados
  useEffect(() => {
    const colorMap = {
      's.configuracao.tanquefisico.manual': '#d32f2f',
      's.configuracao.bico.automaticobico': '#008000',
      's.geral.semiautomatico': '#ff8c00',
    };

    const newColors = data.map(
      (item) => colorMap[item.tipoabastecimento] || '#dfcc27'
    );

    const totalSum = data.reduce(
      (acc, item) => acc + item.registrostipoabastecimento,
      0
    );

    setColors(newColors);
    setSum(totalSum);
  }, [data]);

  const chartOptions = {
    labels: data.map((item) => t(item.tipoabastecimento)),
    colors,
    dataLabels: {
      enabled: true,
      formatter(val) {
        return `${number(val, 2)}%`;
      },
      dropShadow: {
        enabled: false,
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
          offset: -10,
        },
        dropShadow: {
          enabled: false,
        },
      },
    },
    stroke: {
      width: 0,
    },
    legend: {
      position: 'bottom',
      wrap: true,
      formatter(seriesName, opts) {
        const rawValue = opts.w.config.series[opts.seriesIndex];

        const percentage = (rawValue / sum) * 100;

        return `${t(seriesName)}<br> ${number(rawValue)} (${number(
          percentage,
          1
        )}%)`;
      },
    },
  };

  return (
    <Card
      title={t('s.dashboard.visaogeral.tiposabastecimento')}
      icon={<Opacity />}
      style={style}
      tooltip={t('s.dashboard.visaogeral.tooltip.tipoabastecimento')}
    >
      {data && data.length > 0 ? (
        <Chart
          width="100%"
          height="100%"
          type="pie"
          series={data.map((item) => item.registrostipoabastecimento)}
          options={chartOptions}
        />
      ) : (
        <SemDados />
      )}
    </Card>
  );
}

CardTiposAbast.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      tipoabastecimento: PropTypes.string.isRequired,
      registrostipoabastecimento: PropTypes.number.isRequired,
    })
  ).isRequired,
  style: PropTypes.objectOf(PropTypes.any),
};

CardTiposAbast.defaultProps = {
  style: {},
};

export default CardTiposAbast;
